import styled from 'styled-components'
import { NumericFormat } from 'react-number-format'

export const Container = styled.div`
  width: 100%;
  background-color: #FFFFFF;
  box-shadow: 0px 2px 10px -6px #252525;
  grid-template-columns: 3fr 2fr 2fr;
  text-decoration: none;
  border-radius: 15px;
  margin-bottom: 10px;
  display: grid;
  align-items: center;
  justify-items: center;
  padding: 7px 15px;
`

export const InfoText = styled.p`
  font-size: 14px;
  text-align: center;
  color: #000000;
  margin: 0px;
`

export const SubTitle = styled(InfoText)`
  font-weight: bold;
  line-height: 16px;
`

export const MoneyTextMask = styled(NumericFormat).attrs (props => {
  return {
    value: props.value.toFixed (2).replace ('.', ','),
    thousandSeparator: '.',
    decimalSeparator: ',',
    displayType: 'text',
    prefix: 'R$ '
  }
})`
  color: ${({value}) => parseFloat (value.replace (',', '.')) >= 0 ? '#44CF6C' : '#FF3939'};
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0px;
  padding: 0px;
`
